import { Image as ImageIcon } from "lucide-react";

/**
 * Editorial placeholder. Real images can be passed later via `src`.
 * variant: "hero" | "tall" | "wide" | "square" | "round" | "card"
 */
export default function Placeholder({
  variant = "wide",
  label = "Photo",
  Icon = ImageIcon,
  className = "",
  src,
  alt = "",
  testId,
}) {
  const variantClasses = {
    hero: "w-full h-full min-h-[520px] arch-top",
    tall: "w-full aspect-[3/4] rounded-2xl",
    wide: "w-full aspect-[16/10] rounded-2xl",
    square: "w-full aspect-square rounded-2xl",
    round: "w-full aspect-square rounded-full",
    card: "w-full aspect-[4/5] rounded-2xl",
  };

  const cls = `${variantClasses[variant] || variantClasses.wide} ${className}`;

  if (src) {
    return <img src={src} alt={alt} className={`${cls} object-cover`} data-testid={testId} />;
  }

  return (
    <div className={`ph-base ${cls}`} data-testid={testId || "placeholder"}>
      <Icon className="w-8 h-8" strokeWidth={1.5} />
      <span className="ph-label">{label}</span>
    </div>
  );
}
